export const toTitleCase = (s: string) => {
  return s
    .split(/\s+/i)
    .map((w) =>
      w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w,
    )
    .join(' ');
};
